import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LoginFlowPageRoutingModule } from './login-flow-routing.module';

import { LoginFlowPage } from './login-flow.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, LoginFlowPageRoutingModule, ComponentsModule],
  declarations: [LoginFlowPage],
})
export class LoginFlowPageModule {}
